(function(factory) {
	if (typeof define === "function" && define.amd) {
		// AMD. Register as an anonymous module.
		define(["jquery"], factory);
	} else if (typeof module === "object" && module.exports) {
		// Node/CommonJS
		module.exports = factory(require("jquery"));
	} else {
		// Browser globals
		factory(jQuery);
	}
})(function($) {
	$.fn.chart = function() {
		this.each(function() {
			var chart = this;
			var $this = $(this);
			var items = $this.find(".Chart__Item");
			function getData() {
				var data = [];
				$(items).each(function(index, item) {
					data.push({
						value: parseFloat($(item).data("value")),
						price: parseFloat($(item).data("price")).toFixed(2),
						color: $(item).data("color"),
						tooltipHeadline: $(item).data("tooltipHeadline")
					});
				});

				return data;
			}

			function draw() {
				$this.drawDoughnutChart(getData());
			}
			draw();
			$(window).on("resize", function(event) {
				$this.empty();
				$(".doughnutTip").remove();
				draw();
			});
		});
	};

	$.fn.drawDoughnutChart = function(data, options) {
		var $this = this,
			W = $this.width(),
			H = $this.width(),
			centerX = W / 2,
			centerY = H / 2,
			cos = Math.cos,
			sin = Math.sin,
			settings = $.extend(
				{
					segmentShowStroke: true,
					segmentStrokeColor: "#0C1013",
					segmentStrokeWidth: 0,
					baseColor: "black",
					baseOffset: 4,
					edgeOffset: 10, //offset from edge of $this
					percentageInnerCutout: 0,
					animation: false,
					animationSteps: 90,
					animationEasing: "easeInOutExpo",
					animateRotate: true,
					tipOffsetX: -14,
					tipOffsetY: -45,

					tipClass: "doughnutTip",
					summaryClass: "doughnutSummary",
					summaryTitle: "TOTAL:",
					summaryTitleClass: "doughnutSummaryTitle",
					summaryNumberClass: "doughnutSummaryNumber",
					beforeDraw: function() {},
					afterDrawed: function() {},
					onPathEnter: function(e, data) {},
					onPathLeave: function(e, data) {}
				},
				options
			),
			animationOptions = {
				linear: function(t) {
					return t;
				},
				easeInOutExpo: function(t) {
					var v = t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
					return v > 1 ? 1 : v;
				}
			},
			requestAnimFrame = (function() {
				return (
					window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					window.oRequestAnimationFrame ||
					window.msRequestAnimationFrame ||
					function(callback) {
						window.setTimeout(callback, 1000 / 60);
					}
				);
			})();

		settings.beforeDraw.call($this);

		var $svg = $(
				'<svg width="' +
					W +
					'" height="' +
					H +
					'" viewBox="0 0 ' +
					W +
					" " +
					H +
					'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"></svg>'
			).appendTo($this),
			$paths = [],
			easingFunction = animationOptions[settings.animationEasing],
			doughnutRadius = Min([H / 2, W / 2]) - settings.edgeOffset,
			cutoutRadius = doughnutRadius * (settings.percentageInnerCutout / 100),
			segmentTotal = 0;

		var filterID = "filter_" + Math.random();
		var defs = $(
			document.createElementNS("http://www.w3.org/2000/svg", "defs")
		).appendTo($svg);
		var filter = $(
			document.createElementNS("http://www.w3.org/2000/svg", "filter")
		)
			.attr({ id: filterID })
			.appendTo(defs);

		var gaussianFilter = document.createElementNS(
			"http://www.w3.org/2000/svg",
			"feGaussianBlur"
		);
		gaussianFilter.setAttribute("in", "SourceGraphic");
		gaussianFilter.setAttribute("stdDeviation", "3");
		$(gaussianFilter).appendTo(filter);

		//Draw base doughnut
		var baseDoughnutRadius = doughnutRadius + settings.baseOffset,
			baseCutoutRadius = cutoutRadius - settings.baseOffset;
		$(document.createElementNS("http://www.w3.org/2000/svg", "path"))
			.attr({
				d: getHollowCirclePath(baseDoughnutRadius, 0),
				fill: settings.baseColor,
				filter: "url(#" + filterID + ")",
				opacity: 0.2
			})
			.appendTo($svg);

		//Set up Math.PIe segments wrapper
		var $pathGroup = $(
			document.createElementNS("http://www.w3.org/2000/svg", "g")
		);
		$pathGroup.attr({ opacity: 0 }).appendTo($svg);

		for (var i = 0, len = data.length; i < len; i++) {
			segmentTotal += data[i].value;
			$paths[i] = $(
				document.createElementNS("http://www.w3.org/2000/svg", "path")
			)
				.attr({
					"stroke-width": settings.segmentStrokeWidth,
					stroke: settings.segmentStrokeColor,
					fill: data[i].color,
					"data-order": i
				})
				.appendTo($pathGroup)
				.on("mouseenter", pathMouseEnter)
				.on("mouseleave", pathMouseLeave)
				.on("mousemove", pathMouseMove);
		}

		//Animation start
		animationLoop(drawPieSegments);

		//Functions
		function getHollowCirclePath(doughnutRadius, cutoutRadius) {
			//Calculate values for the path.
			//We needn't calculate startRadius, segmentAngle and endRadius, because base doughnut doesn't animate.
			var startRadius = -1.57, // -Math.Math.PI/2
				segmentAngle = 6.2831, // 1 * ((99.9999/100) * (Math.PI*2)),
				endRadius = 4.7131, // startRadius + segmentAngle
				startX = centerX + cos(startRadius) * doughnutRadius,
				startY = centerY + sin(startRadius) * doughnutRadius,
				endX2 = centerX + cos(startRadius) * cutoutRadius,
				endY2 = centerY + sin(startRadius) * cutoutRadius,
				endX = centerX + cos(endRadius) * doughnutRadius,
				endY = centerY + sin(endRadius) * doughnutRadius,
				startX2 = centerX + cos(endRadius) * cutoutRadius,
				startY2 = centerY + sin(endRadius) * cutoutRadius;
			var cmd = [
				"M",
				startX,
				startY,
				"A",
				doughnutRadius,
				doughnutRadius,
				0,
				1,
				1,
				endX,
				endY, //Draw outer circle
				"Z", //Close path
				"M",
				startX2,
				startY2, //Move pointer
				"A",
				cutoutRadius,
				cutoutRadius,
				0,
				1,
				0,
				endX2,
				endY2, //Draw inner circle
				"Z"
			];
			cmd = cmd.join(" ");
			return cmd;
		}
		var $tip;
		function pathMouseEnter(e) {
			//Set up tooltip
			($tip = $('<div class="' + settings.tipClass + '" />')
				.appendTo("body")
				.hide()),
				(tipW = $tip.width()),
				(tipH = $tip.height());

			var order = $(this).data().order;
			$tip.empty();
			$(
				'<div class="Chart__Tooltip"> <div class="Chart__TooltipHeadline">' +
					data[order].tooltipHeadline +
					"</div> <div>" +
					data[order].price.toString().replace(".", ",") +
					" €</div> </div>"
			).appendTo($tip);
			$tip.fadeIn(200);
			// $tip.text(data[order].title + ": " + data[order].value).fadeIn(200);
			settings.onPathEnter.apply($(this), [e, data]);
		}
		function pathMouseLeave(e) {
			$tip.remove();
			settings.onPathLeave.apply($(this), [e, data]);
		}
		function pathMouseMove(e) {
			if ($tip) {
			$tip.css({
				top: e.pageY + settings.tipOffsetY,
				left: e.pageX - $tip.width() / 2 + settings.tipOffsetX
			});
		}
		}
		function drawPieSegments(animationDecimal) {
			var startRadius = -Math.PI / 2, //-90 degree
				rotateAnimation = 1;
			if (settings.animation && settings.animateRotate)
				rotateAnimation = animationDecimal; //count up between0~1

			//drawDoughnutText(animationDecimal, segmentTotal);

			$pathGroup.attr("opacity", animationDecimal);

			//If data have only one value, we draw hollow circle(#1).
			if (
				data.length === 1 &&
				4.7122 <
					rotateAnimation * (data[0].value / segmentTotal * (Math.PI * 2)) +
						startRadius
			) {
				$paths[0].attr("d", getHollowCirclePath(doughnutRadius, cutoutRadius));
				return;
			}
			for (var i = 0, len = data.length; i < len; i++) {
				var segmentAngle =
						rotateAnimation * (data[i].value / segmentTotal * (Math.PI * 2)),
					endRadius = startRadius + segmentAngle + (i < len - 1 ? 0.1 : 0),
					largeArc =
						(endRadius - startRadius) % (Math.PI * 2) > Math.PI ? 1 : 0,
					startX = centerX + cos(startRadius) * doughnutRadius,
					startY = centerY + sin(startRadius) * doughnutRadius,
					endX2 = centerX + cos(startRadius) * cutoutRadius,
					endY2 = centerY + sin(startRadius) * cutoutRadius,
					endX = centerX + cos(endRadius) * doughnutRadius,
					endY = centerY + sin(endRadius) * doughnutRadius,
					startX2 = centerX + cos(endRadius) * cutoutRadius,
					startY2 = centerY + sin(endRadius) * cutoutRadius;
				var cmd = [
					"M",
					startX,
					startY, //Move pointer
					"A",
					doughnutRadius,
					doughnutRadius,
					0,
					largeArc,
					1,
					endX,
					endY, //Draw outer arc path
					"L",
					startX2,
					startY2, //Draw line path(this line connects outer and innner arc paths)
					"A",
					cutoutRadius,
					cutoutRadius,
					0,
					largeArc,
					0,
					endX2,
					endY2, //Draw inner arc path
					"Z" //Cloth path
				];
				$paths[i].attr("d", cmd.join(" "));
				$(
					'<div class="Chart__SegmentTextWrapper" style="position: absolute; top:' +
						(centerY +
							sin(startRadius + segmentAngle * 0.5) * doughnutRadius * 0.6) +
						"px; left:" +
						(centerX +
							cos(startRadius + segmentAngle * 0.5) * doughnutRadius * 0.6) +
						'px; "><div class="Chart__SegmentText" style="font-size: ' +
						(W / 20 > 22 ? 22 : W / 20) +
						'px">' +
						data[i].value
							.toFixed(2)
							.toString()
							.replace(".", ",") +
						"%</div></div>"
				).appendTo($this);

				startRadius += segmentAngle;
			}
		}
		function drawDoughnutText(animationDecimal, segmentTotal) {
			$summaryNumber
				.css({ opacity: animationDecimal })
				.text((segmentTotal * animationDecimal).toFixed(1));
		}
		function animateFrame(cnt, drawData) {
			var easeAdjustedAnimationPercent = settings.animation
				? CapValue(easingFunction(cnt), null, 0)
				: 1;
			drawData(easeAdjustedAnimationPercent);
		}
		function animationLoop(drawData) {
			var animFrameAmount = settings.animation
					? 1 / CapValue(settings.animationSteps, Number.MAX_VALUE, 1)
					: 1,
				cnt = settings.animation ? 0 : 1;
			requestAnimFrame(function() {
				cnt += animFrameAmount;
				animateFrame(cnt, drawData);
				if (cnt <= 1) {
					requestAnimFrame(arguments.callee);
				} else {
					settings.afterDrawed.call($this);
				}
			});
		}
		function Max(arr) {
			return Math.max.apply(null, arr);
		}
		function Min(arr) {
			return Math.min.apply(null, arr);
		}
		function isNumber(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		}
		function CapValue(valueToCap, maxValue, minValue) {
			if (isNumber(maxValue) && valueToCap > maxValue) return maxValue;
			if (isNumber(minValue) && valueToCap < minValue) return minValue;
			return valueToCap;
		}
		return $this;
	};
});

/*!
 * jquery.drawDoughnutChart.js
 * Version: 0.4.1(Beta)
 * InsMath.PIred by Chart.js(http://www.chartjs.org/)
 *
 * Copyright 2014 hiro
 * https://github.com/githiro/drawDoughnutChart
 * Released under the MIT license.
 *
 */
(function($, undefined) {})(jQuery);
